import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import "./style.css";

const DEFAULT_NAV_LINKS = [
  { label: "Acasă", path: "/" },
  { label: "Despre noi", path: "/despre-noi" },
  { label: "Misiune", path: "/misiune" },
  { label: "Evenimente", path: "/evenimente" },
  { label: "Contact", path: "/contact" },
];

const PloomFooter = () => {
  const [navLinks, setNavLinks] = useState(DEFAULT_NAV_LINKS);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_BASE}/settings/get?category=siteDesign`)
      .then((res) => {
        const data = Array.isArray(res.data) ? res.data : [];
        if (data.length > 0 && Array.isArray(data[0].footerLinks) && data[0].footerLinks.length > 0) {
          setNavLinks(data[0].footerLinks);
        }
      })
      .catch(() => {/* use defaults */});
  }, []);

  const handleWhatsApp = () => {
    window.open("https://wa.me/40743222996", "_blank", "noopener,noreferrer");
  };

  return (
    <footer className="new-footer">
      <div className="new-footer__inner">
        {/* Top grid */}
        <div className="new-footer__grid">
          {/* Brand column */}
          <div className="new-footer__brand">
            <Link
              to="/"
              className="new-footer__logo"
              onClick={() => window.scrollTo(0, 0)}
            >
              <img src="/logo/logo complet ploom tm.png" alt="The Oils Babe" />
            </Link>
            <p className="new-footer__tagline">
              Din natură, pentru echilibrul tău interior.
            </p>
            <div className="new-footer__social">
              <button
                className="new-footer__social-btn"
                onClick={handleWhatsApp}
                aria-label="WhatsApp"
              >
                <i className="fi flaticon-new-whatsapp"></i>
              </button>
              <a
                href="https://www.facebook.com/ariana.henzel1"
                target="_blank"
                rel="noopener noreferrer"
                className="new-footer__social-btn"
                aria-label="Facebook"
              >
                <i className="fi flaticon-facebook-app-symbol"></i>
              </a>
              <a
                href="https://www.instagram.com/ariana.henzel?igsh=MTN3MDJ0dTJ1am16Mg=="
                target="_blank"
                rel="noopener noreferrer"
                className="new-footer__social-btn"
                aria-label="Instagram"
              >
                <i className="fi flaticon-instagram"></i>
              </a>
            </div>
          </div>

          {/* Nav columns */}
          <div className="new-footer__nav-col">
            <p className="new-footer__col-title">Navigare</p>
            <ul>
              {navLinks.map((link, i) => (
                <li key={i}>
                  <Link to={link.path} onClick={() => window.scrollTo(0, 0)}>
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>


        </div>
      </div>
    </footer>
  );
};

export default PloomFooter;
